import React, { PropTypes } from 'react';
import ProportionBar from './ProportionBar.js';

const Profile = React.createClass({
  displayName: "Profile",
  propTypes: {
    person: PropTypes.object,
    party: PropTypes.string,
    showingPercentage: PropTypes.bool
  },
  render() {
    const { person, party, showingPercentage } = this.props;
    const realName = person.name.replace('_', '\'');
    const [firstName, lastName] = realName.split(' ');
    const imgName = person.name.replace('_', '-').replace(' ', '_').toLowerCase();
    const winnerImg = `img/new/${imgName}.jpg`;
    const css = require('./Profile.scss');

    return (
      <div className={css.profile}>
        <img src={winnerImg} className={css.img} title={realName} />
        <p className={css.name}>
          <a href="http://pejl.svt.se/usa-val/kandidaterna">
            <span className={css.firstName}>{firstName}</span>{' '}
            <span>{lastName}</span>
          </a>
        </p>
        <ProportionBar total={100} part={person.delegateShare} delegates={person.delegates} party={party} showingPercentage={showingPercentage} />
      </div>
    );
  }
});

export default Profile;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Profile.js
 **/